import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import api from "../../../../services/axios";
import Modal from "../../../../components/modal";

interface Props {
  clientId: number;
  clientName: string;
  onClose: () => void;
}

const ReportPreviewModal: React.FC<Props> = ({ clientId, clientName, onClose }) => {
  const [html, setHtml] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get<string>(`/Financial/ReportPreview/${clientId}`, {
          responseType: "text",
          transformResponse: [(d) => d],
        });
        if (active) setHtml(res.data);
      } catch (err: any) {
        if (active) setError("Não foi possível gerar o preview (cliente sem horas na semana?).");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [clientId]);

  return (
    <Modal onClose={onClose}>
      <div
        className="flex h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-dv-lg dark:bg-navy-800"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-3 dark:border-gray-700">
          <div>
            <h3 className="font-bold text-navy-700 dark:text-white">Prévia do report</h3>
            <p className="text-xs text-gray-500 dark:text-gray-400">{clientName} · última semana</p>
          </div>
          <button
            aria-label="Fechar"
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-navy-700"
          >
            <MdClose className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        <div className="flex-1 overflow-hidden bg-[#f4f7fe]">
          {loading ? (
            <div className="flex h-full items-center justify-center text-sm text-gray-500">
              Gerando preview...
            </div>
          ) : error ? (
            <div className="flex h-full items-center justify-center px-6 text-center text-sm text-gray-600">
              {error}
            </div>
          ) : (
            <iframe
              title="Report preview"
              srcDoc={html}
              className="h-full w-full border-0"
              sandbox=""
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ReportPreviewModal;
